import { getOverrideRows } from "@/lib/copyOverrides";

const ENDPOINT =
  "https://jhgvpqnesquocndbzygl.supabase.co/functions/v1/promo-events";

const SITE = "sons-guadalupe";

export type PromoSurface = "banner" | "popup";
export type PromoEvent = "view" | "click";

function skip(): boolean {
  if (typeof window === "undefined") return true;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has("promo_preview")) return true;
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1" || host === "::1") return true;
    if (host.includes("lovable")) return true;
  } catch {
    return true;
  }
  return false;
}

async function surfaceHash(surface: PromoSurface): Promise<string> {
  const rows = getOverrideRows();
  const values: Record<string, string> = {};
  for (const [k, v] of rows) {
    if (k.startsWith(`${surface}.`)) values[k] = v;
  }
  const entries = Object.entries(values).sort(([a], [b]) =>
    a < b ? -1 : a > b ? 1 : 0,
  );
  const message =
    entries.length === 0 ? "{}" : JSON.stringify(Object.fromEntries(entries));
  const buf = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(message),
  );
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function sendPromoEvent(surface: PromoSurface, event: PromoEvent): void {
  if (skip()) return;
  void (async () => {
    try {
      const body = JSON.stringify({
        site: SITE,
        surface,
        event,
        hash: await surfaceHash(surface),
        path: window.location.pathname,
        ts: Date.now(),
      });
      try {
        if (navigator.sendBeacon) {
          const blob = new Blob([body], { type: "application/json" });
          if (navigator.sendBeacon(ENDPOINT, blob)) return;
        }
      } catch {
        /* ignore */
      }
      void fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    } catch {
      /* ignore */
    }
  })();
}
